import Home from "../views/Home";
import Connection from "../views/Connection.vue";
import P404 from "../views/P404.vue";
import { i18n } from "@/services/vue-i18n";

export default [
  {
    path: "/",
    name: i18n.t("app.navigation.home"),
    component: Home
  },
  {
    path: "/connection",
    name: i18n.t("app.login.title"),
    component: Connection
  },
  {
    path: "*",
    alias: "404",
    component: P404
  }
];
